var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "entry-multi-tab" },
    [
      _c(
        "div",
        { staticClass: "entry-multi-tab__menus" },
        [
          _c("icon-font", {
            staticStyle: { "font-size": "14px", cursor: "pointer" },
            attrs: { type: "gb-icon-appstore" },
            on: {
              click: function ($event) {
                _vm.visible = true
              },
            },
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              staticClass: "entry-multi-tab__menus__wrapper",
            },
            [
              _c(
                "div",
                { staticClass: "entry-multi-tab__menus__wrapper__main" },
                [
                  _c("div", { staticClass: "entry-menus-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "entry-menus-wrapper__hd" },
                      [
                        _c("icon-font", {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { type: "gb-icon-appstore" },
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.$t("layouts.allmenu")))]),
                        _c("icon-font", {
                          staticStyle: {
                            "font-size": "22px",
                            cursor: "pointer",
                          },
                          attrs: { type: "gb-icon-guanbi" },
                          on: {
                            click: function ($event) {
                              _vm.visible = false
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "entry-menus-wrapper__search" },
                      [
                        _c(
                          "a-input",
                          {
                            attrs: {
                              "allow-clear": "",
                              size: "large",
                              placeholder: _vm.$t("layouts.menusearch"),
                            },
                            model: {
                              value: _vm.keyword,
                              callback: function ($$v) {
                                _vm.keyword = $$v
                              },
                              expression: "keyword",
                            },
                          },
                          [
                            _c("a-icon", {
                              attrs: { slot: "prefix", type: "search" },
                              slot: "prefix",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.keyword
                      ? _c(
                          "div",
                          { staticClass: "entry-menus-wrapper__bd" },
                          [
                            _c("entry-menus-search", {
                              attrs: {
                                menus: _vm.menus,
                                favorites: _vm.favorites,
                                keyword: _vm.keyword,
                                currentLang: _vm.currentLang,
                                tabActiveKey: _vm.tabActiveKey,
                              },
                              on: {
                                click: (key) =>
                                  _vm.onChange(key, {
                                    statisticsType: 1,
                                    searchKey: _vm.keyword,
                                  }),
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "entry-menus-wrapper__bd" },
                          [
                            _c("menus-item", {
                              attrs: {
                                tabActiveKey: _vm.tabActiveKey,
                                currentLang: _vm.currentLang,
                                menu: _vm.menusLevel2,
                                "active-key": _vm.tabActiveKey,
                                favorites: _vm.favorites,
                              },
                              on: {
                                click: (key) =>
                                  _vm.onChange(key, { statisticsType: 1 }),
                              },
                            }),
                          ],
                          1
                        ),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "entry-menus-silder" },
                [
                  _vm._l(
                    _vm.menusLevel2.childMenus.filter(
                      (find) => find.updateFlag === 1
                    ),
                    function (menu) {
                      return [
                        _c(
                          "div",
                          {
                            key: menu.key,
                            staticClass: "entry-menus-silder__item",
                            class: {
                              "entry-menus-silder__item--active":
                                _vm.tabActiveKey === menu.key,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onTabChange(menu.key)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm._f("menuNameRender")(menu))),
                            ]),
                          ]
                        ),
                      ]
                    }
                  ),
                ],
                2
              ),
            ]
          ),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visible,
                expression: "visible",
              },
            ],
            staticClass: "entry-multi-tab__menus__mask",
            on: {
              click: function ($event) {
                _vm.visible = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "main",
        { staticClass: "entry-multi-tab__wrapper" },
        [
          _vm.panes && _vm.panes.length
            ? _c(
                "div",
                {
                  staticClass: "entry-multi-tab-item",
                  class: {
                    "entry-multi-tab-item__active":
                      _vm.activeKey === _vm.panes[0].key,
                  },
                  staticStyle: { padding: "0 10px" },
                  on: {
                    click: () =>
                      _vm.onChange(_vm.panes[0].key, { statisticsType: 1 }),
                  },
                },
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "14px" },
                    attrs: { type: "home" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.directionFlag
            ? _c(
                "div",
                {
                  staticClass:
                    "entry-multi-tab-item entry-multi-tab-item__direction",
                  class: { disabled: _vm.directionFlag === -1 },
                  on: {
                    click: function ($event) {
                      return _vm.rollTo(-1)
                    },
                  },
                },
                [_c("a-icon", { attrs: { type: "left" } })],
                1
              )
            : _vm._e(),
          _c(
            "SlickList",
            {
              ref: "slickListRef",
              staticClass: "entry-multi-tab-list",
              attrs: {
                lockAxis: "x",
                axis: "x",
                lockToContainerEdges: "",
                distance: 20,
                "helper-class": "entry-multi-tab-item__drop",
                tag: "ul",
              },
              on: { input: _vm.sortDropDone },
              model: {
                value: _vm.items,
                callback: function ($$v) {
                  _vm.items = $$v
                },
                expression: "items",
              },
            },
            _vm._l(_vm.items, function (pane, index) {
              return _c(
                "SlickItem",
                {
                  key: pane.key,
                  staticClass: "entry-multi-tab-item",
                  class: {
                    "entry-multi-tab-item__active": _vm.activeKey === pane.key,
                  },
                  attrs: { index: index, tag: "li" },
                  nativeOn: {
                    click: function ($event) {
                      return (() =>
                        _vm.onChange(pane.key, { statisticsType: 1 })).apply(
                        null,
                        arguments
                      )
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm._f("menuNameRender")(pane)) + " "),
                  pane.closable
                    ? _c("a-icon", {
                        staticStyle: {
                          "font-size": "12px",
                          "margin-left": "4px",
                        },
                        attrs: { type: "close" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return (() => _vm.remove(pane.key)).apply(
                              null,
                              arguments
                            )
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
          _vm.directionFlag
            ? _c(
                "div",
                {
                  staticClass:
                    "entry-multi-tab-item entry-multi-tab-item__direction",
                  class: { disabled: _vm.directionFlag === 1 },
                  on: {
                    click: function ($event) {
                      return _vm.rollTo(1)
                    },
                  },
                },
                [_c("a-icon", { attrs: { type: "right" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-dropdown",
        {
          attrs: { slot: "tabBarExtraContent", trigger: ["click"] },
          slot: "tabBarExtraContent",
        },
        [
          _c(
            "div",
            { staticClass: "dropdown-content" },
            [_c("a-icon", { attrs: { type: "down" } })],
            1
          ),
          _c(
            "a-menu",
            {
              attrs: { slot: "overlay" },
              on: { click: _vm.closeMenuClick },
              slot: "overlay",
            },
            [
              _c("a-menu-item", { key: "ClosePane" }, [
                _vm._v(_vm._s(_vm.$t("tabs.close.current"))),
              ]),
              _c("a-menu-item", { key: "CloseRightPanes" }, [
                _vm._v(_vm._s(_vm.$t("tabs.close.right"))),
              ]),
              _c("a-menu-item", { key: "CloseLeftPanes" }, [
                _vm._v(_vm._s(_vm.$t("tabs.close.left"))),
              ]),
              _c("a-menu-item", { key: "CloseAllPane" }, [
                _vm._v(_vm._s(_vm.$t("tabs.close.all"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "demo",
              rawName: "v-demo",
              value: "guideToLive",
              expression: "'guideToLive'",
            },
          ],
          staticClass: "entry-oguide",
          staticStyle: { "border-right": "1px solid #E5E8EB" },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "13",
                height: "13",
                viewBox: "0 0 13 13",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M4.69043 4.52224C4.69043 4.255 4.88015 4.14503 5.11275 4.27576L8.88836 6.39733C9.12157 6.52842 9.12096 6.74135 8.88836 6.87196L5.11275 8.99354C4.87954 9.12463 4.69043 9.0143 4.69043 8.74705V4.52224Z",
                  fill: "white",
                  stroke: "#4E535C",
                },
              }),
              _c("circle", {
                attrs: {
                  cx: "6.33789",
                  cy: "6.875",
                  r: "5.625",
                  stroke: "#4E535C",
                },
              }),
            ]
          ),
          _c("span", { staticStyle: { "margin-left": "5px" } }, [
            _vm._v(_vm._s(_vm.$t("layouts.直播/回放"))),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "demo",
              rawName: "v-demo",
              value: "guideTo",
              expression: "'guideTo'",
            },
          ],
          staticClass: "entry-oguide",
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "11",
                height: "13",
                viewBox: "0 0 11 13",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M8.20879 4.6995C8.09941 4.65738 7.98047 4.66009 7.87383 4.70629L4.16875 6.31773L2.54863 9.99987C2.49941 10.1113 2.49941 10.2376 2.54863 10.3491C2.59512 10.455 2.68125 10.5379 2.79062 10.58C2.84258 10.6004 2.8959 10.6099 2.95059 10.6099C3.01074 10.6099 3.06953 10.5977 3.12559 10.5732L6.83066 8.9618L8.45078 5.27967C8.5 5.16825 8.5 5.04189 8.45078 4.93048C8.40293 4.82314 8.3168 4.74162 8.20879 4.6995ZM6.38223 7.94004L6.74043 8.29603L6.16074 8.87213L5.80254 8.51614L3.6916 9.43464L4.61445 7.33677L4.26582 6.98894L4.84551 6.41284L5.19414 6.75932L7.30644 5.84218L6.38223 7.94004Z",
                  fill: "#4E535C",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M4.84531 6.41284L4.26562 6.98894L4.61426 7.33677L5.80234 8.51614L6.16055 8.87213L6.74023 8.29603L6.38203 7.94004L5.19531 6.75932L4.84531 6.41284Z",
                  fill: "#4E535C",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M8.99952 0.671875C9.27356 0.671875 9.49711 0.90771 9.5 1.19886V2.80167H10.4995C10.775 2.80167 11 3.0375 11 3.33448V3.86729H0V1.73604C0 1.14791 0.448557 0.671875 0.995192 0.671875H8.99952ZM8.50048 1.73604H1.49712C1.22163 1.7375 0.999519 1.97479 1.00096 2.26886C1.00096 2.56438 1.22308 2.80167 1.49712 2.80167H8.50048V1.73604ZM0 3.86584H11V11.5377C11 12.123 10.5514 12.5975 9.99759 12.5975H1.0024C0.737019 12.599 0.483173 12.4869 0.294231 12.2889C0.106731 12.0895 0 11.8202 0 11.5377V3.86584ZM0.999519 3.86584V11.0035C1.0024 11.2946 1.22308 11.529 1.49567 11.5319H9.50432C9.77692 11.529 9.99759 11.2946 10.0005 11.0035V3.86584H0.999519Z",
                  fill: "#4E535C",
                },
              }),
            ]
          ),
          _c("span", { staticStyle: { "margin-left": "5px" } }, [
            _vm._v(_vm._s(_vm.$t("layouts.operation.guide"))),
          ]),
        ]
      ),
      _c("a-popover", { attrs: { placement: "bottom" } }, [
        _c(
          "div",
          { staticClass: "entry-bookmarks" },
          [
            _c("img", {
              staticClass: "entry-bookmarks-icon",
              attrs: { src: require("@/assets/start.png") },
            }),
            _c("span", { staticClass: "entry-bookmarks-text" }, [
              _vm._v(_vm._s(_vm.$t("layouts.bookmarks"))),
            ]),
            _c("a-icon", {
              staticStyle: { "margin-left": "5px" },
              attrs: { type: "caret-down" },
            }),
          ],
          1
        ),
        _vm.favorites.length
          ? _c(
              "div",
              {
                staticClass: "entry-bookmarks-wrapper",
                attrs: { slot: "content" },
                slot: "content",
              },
              [
                _c(
                  "div",
                  { staticClass: "entry-bookmarks-list" },
                  _vm._l(_vm.favorites, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.key,
                        staticClass: "entry-bookmarks-list__item",
                        on: {
                          click: function ($event) {
                            return _vm.onChange(item.key, {
                              statisticsType: 2,
                              searchKey: "",
                            })
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "entry-bookmarks-list__thumb",
                          attrs: {
                            src: require("@/assets/bookmark.png"),
                            alt: "",
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "entry-bookmarks-list__title" },
                          [_vm._v(_vm._s(_vm._f("menuLocalName")(item)))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass: "entry-bookmarks-btn",
                    on: {
                      click: function ($event) {
                        _vm.visible = true
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("layouts.manageFavorites")))]
                ),
              ]
            )
          : _c(
              "div",
              {
                staticClass: "entry-bookmarks-wrapper",
                attrs: { slot: "content" },
                slot: "content",
              },
              [
                _c("div", { staticClass: "entry-bookmarks-list" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#999",
                        "text-align": "center",
                        "line-height": "48px",
                      },
                    },
                    [
                      _vm._v(
                        "-- " + _vm._s(_vm.$t("layouts.text.undefined")) + " --"
                      ),
                    ]
                  ),
                ]),
              ]
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }